import React from 'react';
import { motion } from 'framer-motion';
import './cookie.css';

const CookiePolicy = () => {
  return (
    <motion.div
      className="cookie-policy"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 1 }}
    >
      <motion.h1
        initial={{ opacity: 0, y: -30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1.2, ease: 'easeInOut' }}
      >
        Cookie Policy
      </motion.h1>

      <motion.section
        initial={{ opacity: 0, x: -50 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 1, delay: 0.2 }}
      >
        <h2>1. Introduction</h2>
        <p>
          This Cookie Policy explains how ARCITY uses cookies and similar technologies when you visit our website. By using our website, you consent to the use of cookies in accordance with this policy.
        </p>
      </motion.section>

      <motion.section
        initial={{ opacity: 0, x: 50 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 1, delay: 0.4 }}
      >
        <h2>2. What are Cookies?</h2>
        <p>
          Cookies are small text files stored on your device when you visit a website. They are used to make websites work more efficiently, to improve user experience, and to provide information to the owners of the site.
        </p>
      </motion.section>

      <motion.section
        initial={{ opacity: 0, x: -50 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 1, delay: 0.6 }}
      >
        <h2>3. Types of Cookies We Use</h2>
        <p>
          We use the following types of cookies:
        </p>
        <ul>
          <li><strong>Strictly Necessary Cookies:</strong> These are essential for the operation of our website and cannot be switched off in our systems.</li>
          <li><strong>Performance Cookies:</strong> These cookies collect information about how visitors use our website, allowing us to improve the performance of our site.</li>
          <li><strong>Functional Cookies:</strong> These cookies enable enhanced functionality and personalization, such as remembering your preferences and settings.</li>
          <li><strong>Targeting Cookies:</strong> These cookies record your visit to our site, the pages you visit, and the links you follow. This information is used to display relevant ads on third-party websites.</li>
        </ul>
      </motion.section>

      <motion.section
        initial={{ opacity: 0, x: 50 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 1, delay: 0.8 }}
      >
        <h2>4. How We Use Cookies</h2>
        <p>
          We use cookies to:
        </p>
        <ul>
          <li>Ensure our website functions properly.</li>
          <li>Remember your preferences and improve your experience.</li>
          <li>Analyze website traffic and usage trends.</li>
          <li>Provide personalized content and advertisements.</li>
        </ul>
      </motion.section>

      <motion.section
        initial={{ opacity: 0, x: -50 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 1, delay: 1.0 }}
      >
        <h2>5. Third-Party Cookies</h2>
        <p>
          In some cases, we may work with third-party service providers who set cookies to deliver specific functionality or advertisements. These third-party cookies are governed by the privacy policies of the respective providers.
        </p>
      </motion.section>

      <motion.section
        initial={{ opacity: 0, x: 50 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 1, delay: 1.2 }}
      >
        <h2>6. Managing Cookies</h2>
        <p>
          You can manage your cookie preferences by adjusting the settings in your browser. Most browsers allow you to refuse cookies or delete them. However, disabling cookies may affect the functionality of our website.
        </p>
      </motion.section>

      <motion.section
        initial={{ opacity: 0, x: -50 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 1, delay: 1.4 }}
      >
        <h2>7. Cookie Duration</h2>
        <p>
          The duration of time that a cookie stays on your device depends on whether it is a "persistent" or "session" cookie. Session cookies last only until you close your browser, while persistent cookies remain on your device for a set period or until deleted.
        </p>
      </motion.section>

      <motion.section
        initial={{ opacity: 0, x: 50 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 1, delay: 1.6 }}
      >
        <h2>8. Updates to This Cookie Policy</h2>
        <p>
          We may update this Cookie Policy from time to time to reflect changes in our practices or for other operational, legal, or regulatory reasons. Please review this policy regularly to stay informed about our use of cookies.
        </p>
      </motion.section>

      <motion.section
        initial={{ opacity: 0, x: -50 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 1, delay: 1.8 }}
      >
        <h2>9. Contact Us</h2>
        <p>
          If you have any questions about this Cookie Policy or how we use cookies, please contact us at arcity0fficial@gmail.com or +92 3009402541.
        </p>
      </motion.section>
    </motion.div>
  );
};

export default CookiePolicy;
